import React from 'react';
import { Globe, MapPin } from 'lucide-react';

const OnlineOfflineBadge = () => {
  return (
    <section className="bg-white py-6 border-y border-gray-100" data-testid="online-offline-badge">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto bg-gradient-to-r from-green-600 to-green-700 rounded-2xl p-5 sm:p-6 flex flex-col sm:flex-row items-center gap-4 sm:gap-6 shadow-lg">
          <div className="flex items-center gap-3 flex-shrink-0">
            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-white/20 rounded-xl flex items-center justify-center">
              <Globe className="h-5 w-5 sm:h-6 sm:w-6 text-white" strokeWidth={2.2} />
            </div>
            <div className="w-10 h-10 sm:w-12 sm:h-12 bg-white/20 rounded-xl flex items-center justify-center">
              <MapPin className="h-5 w-5 sm:h-6 sm:w-6 text-white" strokeWidth={2.2} />
            </div>
          </div>
          <div className="flex-1 text-center sm:text-left">
            <strong className="block text-white text-base sm:text-lg font-extrabold leading-snug">
              Online + Offline Classes Available
            </strong>
            <span className="block text-green-50 text-xs sm:text-sm mt-1">
              Join offline at our Bhopal centre, or live online from anywhere in India — same trainer, same syllabus, same quality.
            </span>
          </div>
          <div className="hidden sm:flex flex-col gap-1.5 flex-shrink-0">
            <span className="inline-flex items-center gap-1.5 bg-white text-green-700 px-3 py-1 rounded-full text-xs font-bold">
              <span className="w-1.5 h-1.5 bg-green-600 rounded-full" /> OFFLINE · Bhopal
            </span>
            <span className="inline-flex items-center gap-1.5 bg-white text-green-700 px-3 py-1 rounded-full text-xs font-bold">
              <span className="w-1.5 h-1.5 bg-green-600 rounded-full" /> ONLINE · Pan-India
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OnlineOfflineBadge;
